import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from "react-loading-skeleton";
import axiosInstance from "./../../helpers/axiosInstance";
import MyModal from "components/Modal/Modal";
import santander from '../../assets/img/brand/santander.png';
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';
import ComponentemodificaUsu from './modificaUsuario.js'

import IconTid from '../../assets/img/icons/Icono-Tipo-de-documento-Gris.png'


import icon_Administras_usuarios from 'assets/img/icons/Icono-Administrar-Usuarios-Gris.png'
//import icon_Administras_usuariosA from 'assets/img/icons/Icono-Administrar-Usuarios-Rojo.png'


// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { normalizeUnits } from "moment";
import { tr } from "date-fns/locale";
import basePerfiles from "./basePerfiles.js";
import baseUsuarios from "./baseUsu.js";
import { set } from "date-fns";
import baseTransaccionPen from "./baseTransaccionesPen.js";
import Compotp from "./Compotp";
import Checksantader from "./Checksantander";
import perf from "./basePerfiles.js";
import IconNid from '../../assets/img/icons/Icono-Numero-documento-Gris.png';
import IconCorreo from '../../assets/img/icons/Icono-Correo-Gris.png';
import IconNom from '../../assets/img/icons/Cliente-Gris2x.png';
import IconCel from '../../assets/img/icons/Telefono-Gris2x.png';
import IconPesos from '../../assets/img/icons/Tope_Monto_Transaccional-Gris2x.png';
import IconMas from '../../assets/img/icons/circulo-mas.png';
import IconMasRojo from '../../assets/img/icons/circulo-mas-Verde.png';
import IconEliminar from '../../assets/img/icons/IconoEliminar.png';
import IconEliminarRojo from '../../assets/img/icons/iconoEliminarVerde.png';
import IconCalendario from '../../assets/img/icons/Icono-Contactos-Inscritos-Gris.png';
import IconCalendarioVerde from '../../assets/img/icons/Icono-Contactos-Inscritos-Verde.png';
import Campoformato from "./campoformato";
import { event } from "jquery";
import CalendarioNuevo from "./CalendarioNuevo";
//import { Console } from "console";
const _=require("lodash");

const BotonEliminaIp=(props)=>{
    const [estadoIconIpElimina,setestadoIconIpElimina]=useState(IconEliminar);
    const [indexIp,setindexIp]=useState(props.index);
    const [estadoIconIpAgrega,setestadoIconIpAgrega]=useState(IconMas);
    const [estadoIconDomi,setestadoIconDomi]=useState(IconCalendario);
    const cambiaiconoelimina=(prendido)=>{
        if(prendido){
            setestadoIconIpElimina(IconEliminarRojo);
        }else{
            setestadoIconIpElimina(IconEliminar);
        }
      }
    const eliminaIppadre=(index)=>{
        props.eliminarIp(index);
    }
    const agregaIppadre=()=>{
        props.eliminarIp();
    }
    const cambiaiconoagrega=(prendido)=>{
        if(prendido){
          setestadoIconIpAgrega(IconMasRojo);
        }else{
          setestadoIconIpAgrega(IconMas);
        }
      }
      
    const cambiaiconodomi=(prendido)=>{
      if(prendido){
        setestadoIconDomi(IconCalendarioVerde);
      }else{
        setestadoIconDomi(IconCalendario);
      }

    }

    const seleccionafech=(index)=>{
      props.eliminarIp(index);
      
      

    }
    if(props.tipo=="eliminar"){
        return(
            <button className="botonsecundario" onClick={()=>{eliminaIppadre(indexIp)}} onMouseOver={()=>{cambiaiconoelimina(true)}} onMouseOut={()=>{cambiaiconoelimina(false)}}>
            
                <img style={{height:"16px", }} src={estadoIconIpElimina}></img>
        
                Eliminar
            </button>
        );
    }else if(props.tipo=="agregar"){
        return(
            <button className="botonsecundario" onClick={()=>{agregaIppadre()}} onMouseOver={()=>{cambiaiconoagrega(true)}} onMouseOut={()=>{cambiaiconoagrega(false)}}>
              <img style={{height:"16px", }} src={estadoIconIpAgrega}></img>
              Agregar
            </button>
        );
    }else if(props.tipo=="domiciliacion"){
      return(
        <div style={{padding: '1em' }}>
        
        <button className="botonsecundario" style={{background:"none"}} onClick={()=>{seleccionafech(indexIp)}} onMouseOver={()=>{cambiaiconodomi(true)}} onMouseOut={()=>{cambiaiconodomi(false)}}>
          <img style={{height:"16px", }} src={estadoIconDomi}></img>
          Seleccionar
        </button>
        </div>

// {(onClick) => (
//   <div style={{padding: '1em' }}>
//   <Calendario muestra={mostrar} cambio={cambiaFecha} className="col-auto"></Calendario>
//   <button onClick={onClick} className="btn btn-primary">
//       Cerrar calendario
//   </button>
//   </div>
// )}
    );

    }
    
}

export default BotonEliminaIp;